import { render, staticRenderFns } from "./c-board-right@.vue?vue&type=template&id=1bb67a3e&"
import script from "./c-board-right@.vue?vue&type=script&lang=ts&"
export * from "./c-board-right@.vue?vue&type=script&lang=ts&"
import style0 from "./c-board-right@.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports